var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex align-center justify-center",attrs:{"flat":""}},[_c('v-img',{attrs:{"src":require("@/assets/comingSoon.svg"),"contain":"","width":"700","height":"700"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }